
import { Component, Vue } from 'vue-property-decorator'
import MainService from '@/services/main'
import Overlay from '@/components/Overlay.vue'
import Swal from 'sweetalert2'

@Component({
  components: { Overlay }
})
export default class Home extends Vue {
  loading = false
  name = ''
  email = ''
  dream = ''
  text = ''
  links: Array<{ name: string; link: string; }> = []
  prices: Array<{ country: string; currency: string; price_double: number; price_single: number; }> = []
  priceSingle = 37
  priceDouble = 58
  priceCurrency = 'USD'

  mounted (): void {
    this.getPaymentLinks()
    this.getPrices()
  }

  async register (): Promise<void> {
    this.loading = true
    const [error, response] = await MainService.register({
      username: this.name,
      email: this.email,
      dream: this.dream
    })
    this.loading = false
    if (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Ocurrio un error intenta mas tarde'
      })
      return
    }
    this.text = response.data.miira_text
    await this.sleep(300)
    this.animationText()
  }

  async getPaymentLinks (): Promise<void> {
    this.loading = true
    const [error, response] = await MainService.getPaymentLinks()
    this.loading = false
    if (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Ocurrio un error intenta mas tarde'
      })
      return
    }
    this.links = response.data
  }

  async getPrices (): Promise<void> {
    this.loading = true
    const [error, response] = await MainService.getPricesPerCountry()
    this.loading = false
    if (error) return
    this.prices = response.data
    this.getLocation()
  }

  async getLocation (): Promise<void> {
    this.loading = true
    const [error, response] = await MainService.getLocation()
    this.loading = false
    if (error) return
    const findPriceByLocation = this.prices.find(price => price.country === response.data.YourFuckingCountry)
    if (findPriceByLocation) {
      this.priceSingle = findPriceByLocation.price_single
      this.priceDouble = findPriceByLocation.price_double
      this.priceCurrency = findPriceByLocation.currency
    } else {
      const priceUSD = this.prices.find(price => price.country === 'United States')
      if (priceUSD) {
        this.priceSingle = priceUSD.price_single
        this.priceDouble = priceUSD.price_double
        this.priceCurrency = priceUSD.currency
      }
    }
  }

  async animationText (): Promise<void> {
    const element = document.getElementById('typing-demo')
    if (element) {
      let content = ''
      for (let index = 0; index < this.text.length; index++) {
        content += this.text.charAt(index)
        await this.sleep(20)
        element.innerText = content
      }
    }
  }

  redirectStripe (type: string) {
    const findLink = this.links.find(link => link.name === type)
    if (findLink) {
      const element = document.createElement('a')
      element.href = findLink.link
      element.target = '_blank'
      element.click()
      element.remove()
    }
  }

  sleep (ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms))
  }
}
